import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Select from "react-select";
import { CLIENT, CLIENT_LIST_FOR_USER, getApiPath } from "../../api/ApiConst";
import ApiCaller from "../../api/ApiCaller";
import { useClient } from '../../config/ClientProvider';
import { jwtDecode } from "jwt-decode";

const HeaderBar = (props) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [clientOptions, setClientOptions] = useState();
    const { selectedClient, updateSelectedClient } = useClient();
    const [username, setUsername] = useState("K. Anderson");

    useEffect(() => {
        const token = localStorage.getItem("access_token");
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                setUsername(decodedToken?.sub || "User");
            } catch (error) {
                console.error("Error decoding token:", error);
                setUsername("User");
            }
        }
    }, []);

    const getClientKeyValueList = () => {
        const clientUrl = getApiPath(CLIENT, CLIENT_LIST_FOR_USER);
        const data = {
            page: 0,
            searchFilters: [],
            size: 100,
            sortRules: []
        };

        ApiCaller.callPostApi(clientUrl, data, {}, (response) => {
            const res = response?.data;
            const _res = res?.map((item) => ({
                label: item.clientName,
                key: item.id,
            }));

            setClientOptions(_res);

            const selectedOption = _res?.find(option => option.key === selectedClient);
            if (selectedOption) {
                updateSelectedClient(selectedOption.key);
            }
        }, (error) => {
            console.error("Error fetching client list:", error);
        });
    };

    useEffect(() => {
        getClientKeyValueList();
    }, []);
    useEffect(() => {
        if(props.isClientPage){
            document.body.classList.add("toggle-sidebar");
        }else{
            document.body.classList.remove("toggle-sidebar");
        }
    }, [props.isClientPage]);

    const handleChange = (value) => {
        if(value?.value==="all-projects"){
            navigate("/client-list");
        }else if(value?.value==="create"){
            navigate("/client-add-update/add-client");
        }else{
            updateSelectedClient(value?.value);
            localStorage.setItem("ScId", value?.value);
        }
      };

    const handleSidebar = () => {
        document.body.classList.toggle("toggle-sidebar");
    };

    const handleSignOut = () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        searchParams.delete("code");
        window.location = "/";
    };

    const groupedOptions = [
        { value: 'create', label: 'Create an Application' },
        { value: 'all-projects', label: 'See All Applicaitons' },
        {
          label: 'Recent', 
          options: clientOptions?.slice(0, 500).map((item) => ({
            value: item.key,
            label: item.label,
          })),
        },
      ];


    return (
        <header id="header" className="header fixed-top d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-between">
                <a href="/" className="logo d-flex align-items-center">
                    <img src={props.project.logo} alt="" />
                    <span className="d-none d-lg-block">{props.project.label}</span>
                </a>
                {!props.isClientPage && (
                    <i className="bi bi-list toggle-sidebar-btn" onClick={handleSidebar} />
                )}
            </div>

            <nav className="header-nav ms-auto">
                <ul className="d-flex align-items-center">
                    {/* Client Selection */}
                    {!props.isClientPage && (
                        <li className="applicationDropdown">
                            <Select
                                options={groupedOptions}
                            onChange={handleChange}
                            value={(clientOptions || []).find(option => option.key === selectedClient) || null}
                            placeholder="Select an Application"
                            className="react-select-container"
                        />
                    </li>
                    )}

                    {/* For space between client selection and User Profile */}
                    <li className="nav-item me-3"></li>
                    {/* Theme Toggle */}
                    {/* <li className="nav-item me-3">
                        <div className="nav-link nav-icon">
                            {Object.entries(themes).map(([key, theme]) => (
                                <button
                                    key={key}
                                    className={`theme-btn ${currentTheme === key ? 'active' : ''}`}
                                    onClick={() => setCurrentTheme(key)}
                                    title={theme.name}
                                >
                                    <i className={theme.icon}></i>
                                </button>
                            ))}
                        </div>
                    </li> */}

                    {/* User Profile */}
                    <li className="nav-item dropdown">
                        <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                            <img src="/assets/img/profile-img.jpg" alt="Profile" className="rounded-circle" />
                            <span className="d-none d-md-block dropdown-toggle ps-2">{username}</span>
                        </a>

                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                            <li className="dropdown-header">
                                <h6>{username}</h6>
                                <span>Web Designer</span>
                            </li>
                            <li><hr className="dropdown-divider" /></li>
                            <li>
                                <a className="dropdown-item d-flex align-items-center" href="/profile">
                                    <i className="bi bi-person"></i>
                                    <span>My Profile</span>
                                </a>
                            </li>
                            <li><hr className="dropdown-divider" /></li>
                            <li>
                                <a className="dropdown-item d-flex align-items-center" href="/settings">
                                    <i className="bi bi-gear"></i>
                                    <span>Settings</span>
                                </a>
                            </li>
                            <li><hr className="dropdown-divider" /></li>
                            <li>
                                <a className="dropdown-item d-flex align-items-center" href="/help">
                                    <i className="bi bi-question-circle"></i>
                                    <span>Need Help?</span>
                                </a>
                            </li>
                            <li><hr className="dropdown-divider" /></li>
                            <li>
                                <button className="dropdown-item d-flex align-items-center" onClick={handleSignOut}>
                                    <i className="bi bi-box-arrow-right"></i>
                                    <span>Sign Out</span>
                                </button>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default HeaderBar;